import type { EpisodeCategory } from '@common/enums';
import type { IServiceStartingPoint } from '@common/interfaces/serviceWorkflow';
import { fetchJson } from '@frontend/store/fetch';

const baseUrl = '/api/episodeCategories';

export async function getIsFlexible(
    episodeCategoryName: EpisodeCategory,
    patientId: string | undefined,
    signal: AbortSignal
): Promise<boolean> {
    let url = `${baseUrl}/${episodeCategoryName}/isFlexible`;

    if (patientId) {
        url += `?patientId=${patientId}`;
    }

    const result = await fetchJson({ method: 'GET', signal, url });

    return result.json.isFlexible;
}

export async function getServiceStartingPoints(
    episodeCategoryName: EpisodeCategory,
    patientId: string,
    signal: AbortSignal
): Promise<IServiceStartingPoint[]> {
    const url = `${baseUrl}/${episodeCategoryName}/serviceStartingPoints?patientId=${patientId}`;
    const result = await fetchJson<IServiceStartingPoint[]>({ method: 'GET', signal, url });

    return result.json ?? [];
}
